<template>
  <div>
    <h2>
      <slot></slot>
    </h2>
    <v-flex sm12 md12 lg12>
      <h2>Terms and Conditions</h2>
      {{ rows.items }}
      <div v-if="!rows.items">
        <div v-for="(row, index) in needsConfirmRows" :key="index">
          <v-card>
            <v-card-text>
              <h2>{{ row.heading }}</h2>
              <v-container
                v-for="(term, tindex) in row.items"
                :key="tindex"
                fluid
                grid-list-xs
                class="pa-0 ma-0"
              >
                <v-layout row>
                  <v-flex shrink>
                    <vonex-checkbox
                      v-model="term.checked"
                      class="shrink pa-0 ma-0"
                      color="success"
                      :rule="`required`"
                    ></vonex-checkbox>
                    <!-- <v-checkbox
                      class="shrink pa-0 ma-0"
                      v-model="term.checked"
                      color="success"
                      :error-messages="errors.collect('term'+term.id)"
                      :data-vv-name="'term'+term.id"
                      validate-on-blur
                      :error="errors.has('term'+term.id)"
                      v-validate="'required:true'"
                    ></v-checkbox> -->
                  </v-flex>
                  <v-flex grow>
                    <table>
                      <tr>
                        <!-- <td>
                          <b>{{tindex+1}}.</b>
                        </td>-->
                        <td>
                          <div v-html="term.condition"></div>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </div>
      </div>
      <h2>CUSTOMER AUTHORISATION</h2>
      <div v-if="!rows.items">
        <div
          v-for="(row, sindex) in needsConfirmRowsFalse"
          :key="`section${sindex}`"
        >
          <h2>{{ row.heading }}</h2>
          <v-layout xs12>
            <v-flex v-if="!!row.items">
              <app-condition
                v-for="(term, cindex) in row.items"
                :key="`category${cindex}`"
              >
                <div :key="cindex" v-html="term.condition"></div>
              </app-condition>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <v-card color="secondary">
        <v-flex sm10 md10 lg10 class="acceptTerms">
          <message-alert :component="message"></message-alert>
        </v-flex>
        <v-layout v-if="!signed" row align-center>
          <v-flex sm8 md8 lg8 class="text-lg-center">
            <p>
              I authorise the supply of the listed products and accept the
              relevant terms and conditions associated with them that can be
              found at
              <a href="www.vonex.com.au">www.vonex.com.au</a>
              including the Direct Debit Authority Terms.
            </p>
          </v-flex>
          <v-flex v-show="!agreed" sm2 md2 lg2>
            <v-btn color="primary" @click="agree">I Agree</v-btn>
            <v-btn color="primary" text-xs-center @click="reject">
              Needs Changes
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import {
  mapTermsConditionsFields,
  mapTermsConditionsMultiRowFields,
} from '../store/modules/orders';
const {
  mapActions: mapTermsConditionsActions,
  mapMutations: mapTermsConditionsMutations,
} = createNamespacedHelpers(`orders/termsConditions`);
const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);
import { httpError } from '../models/httpError';
import AppCondition from './app-condition';

export default {
  components: {
    AppCondition,
  },
  props: {
    signed: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      agreed: false,
      needsConfirmRows: [],
      needsConfirmRowsFalse: [],
    };
  },
  methods: {
    ...mapTermsConditionsActions([
      'populateTerms',
      'setMessage',
      'updateTermsOnOrder',
    ]),
    ...mapTermsConditionsMutations(['']),
    clear() {
      this.errors.clear();
      this.setMessage(new httpError());
    },
    reject() {
      this.$emit('reject');
      return;
    },
    agree() {
      let vm = this;

      vm.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            vm.setMessage({
              message: 'All agreed',
              httpStatus: 200,
            });
            try {
              vm.updateTermsOnOrder().then((data) => {
                vm.agreed = true;
                vm.$emit('agreed');
                return;
              });
            } catch (err) {
              vm.setMessage({
                message: err,
                httpStatus: 500,
              });
            }
          } else {
            vm.setMessage({
              message: 'Unable to save: Check the highlighted fields above',
              httpStatus: 500,
            });
          }
        })
        .catch((err) => {
          vm.setMessage({
            message: err,
            httpStatus: 500,
          });
        });
    },
    switchTerms(section) {
      let items = this.rows.filter(
        (t) => t.needsConfirm == true && t.heading === section
      );
      for (let index = 0; index < items.length; ++index) {
        if (items[index].checked) items[index].checked = false;
        else items[index].checked = true;
      }
    },
  },
  computed: {
    ...mapTermsConditionsMultiRowFields(['rows']),
    ...mapTermsConditionsFields(['message']),
    ...mapOrderState({
      order: 'rows',
    }),
  },
  created() {
    this.populateTerms().then(() => {
      let vm = this;

      let rowsCollect = vm.rows.filter(
        (x) => x.items.filter((y) => y.needsConfirm == true).length > 0
      );

      vm.needsConfirmRows = vm.rows.filter(
        (x) => x.items.filter((y) => y.needsConfirm == true).length > 0
      );
      vm.needsConfirmRowsFalse = vm.rows.filter(
        (x) => x.items.filter((y) => y.needsConfirm == false).length > 0
      );
    });
    this.$root.$on('cancelSign', (data) => {
      this.agreed = data;
    });
  },
};
</script>

<style>
.v-input__control {
  margin: 0px;
}

.v-checkbox label {
  text-decoration-color: black;
}
</style>
